export const FLOWER = 1
export const SHAKE = 2
export const PLANT = 3
export const MATURE = 20
export const EDIBLE = 5
export const TINCTURE = 5
export const TOPICAL = 6
export const TRANSDERMALPATCH = 7
export const EXTRACT = 8
export const CONCENTRATE = 9
export const CAPSULE = 10
export const PREROLLS = 11
export const COMBINEDCATEGORY = 12
export const SUPPOSITORY = 13
export const WASTE = 14
export const ANCILLARY = 15
export const OTHER = 16
export const WHOLEWETPLANT = 18

// categories object
export const categoryTypes = {
  1: 'flower',
  2: 'shake_trim',
  3: 'plant',
  4: 'edibles',
  5: 'tincture',
  6: 'topical',
  7: 'trans_dermal',
  8: 'extract',
  9: 'concentrate',
  10: 'capsule',
  11: 'pre_roll',
  12: 'combined_category',
  13: 'suppository',
  14: 'waste',
  15: 'ancillary',
  16: 'other',
  20: 'mature_plant'
}

// categories object version 2
export const categoryTypesVersion2 = {
  1: 'Flower & Buds',
  2: 'Shake/Trim',
  3: 'Immature Plants',
  4: 'Edibles',
  5: 'Tincture',
  6: 'Topical',
  7: 'Transdermal Patches',
  8: 'Extract',
  9: 'Concentrates',
  10: 'Capsule',
  11: 'Prerolls(Flower)',
  12: 'Combined Category',
  13: 'Suppository',
  14: 'Waste',
  15: 'Ancillary',
  16: 'Other',
  20: 'Mature Plants'
}
